window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');
require('chart.js');
require('magnific-popup');
require('./js/clicktoggle.js');
require('./js/pi.js');
require('./js/chart.js');
require('./js/social_buttons.js');
require('./js/search_clear.js');
require('./js/magnific.js');
